export const API_ENDPOINT = process.env.REACT_APP_apiurl;
export const ORG_ID = () => localStorage.getItem('orgId')